import React, { createContext, useState, useContext } from 'react';

// Create a context for drag state
const DragContext = createContext({
  isDragging: false,
  setIsDragging: () => {},
});

// Provider component
export const DragProvider = ({ children }) => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <DragContext.Provider value={{ isDragging, setIsDragging }}>
      {children}
    </DragContext.Provider>
  );
};

// Custom hook to use the drag context
export const useDragContext = () => useContext(DragContext);
